/* global G */
import { curry } from 'lib/util'

const descriptor = 'model::transformer::toObject'

/**
 * ToJSON Transformer
 *
 * Attempts to transform input string to a JavaScript object.
 *
 * @param {string} key        the name of the attribute to store the data to
 * @param {boolean} [strict]  whether no data property will be created if the value cannot be
 *                            converted into an object
 * @returns {*}
 */
const toObject = (key, strict = false) => curry((obj, data) => {
  const _data = data
  const item = obj[G.CHILDREN][key]
  const { type } = item[G.PROPS]
  const value = obj[G.STATE][G.DATA].value[key]

  try {
    /**
     * Only add the transformed value if it actually existed in the first place.
     * Otherwise, we don't add the property
     */
    value && (_data[type][key] = JSON.parse(value))
  } catch (e) {
    strict
      ? delete _data[type][key]
      : _data[type][key] = value
    strict && console.error(descriptor, e)
  }
  return _data
})

export default toObject
